import dev.shanty.kotwire.stimulus.Application
import kotlinx.browser.window

public fun setupStimulus(): Application {
                  val stimulus = Application.start()
                  registerPlaceSearchController(stimulus)
  registerPlaceSortController(stimulus)
  registerAttachmentDialogController(stimulus)
  registerPackingWhoController(stimulus)
  registerTripMapController(stimulus)
  registerMapController(stimulus)
  registerPackingFormController(stimulus)
  registerCheckboxController(stimulus)
  registerTravelInfoController(stimulus)
  registerConfirmController(stimulus)
  registerFlightStatusController(stimulus)
  registerCopyController(stimulus)
  registerDropdownController(stimulus)
  registerTripSearchController(stimulus)
                  window.asDynamic()["Stimulus"] = stimulus
                  return stimulus
}
